import { renderToString } from 'react-dom/server';

import { ITariff } from '~/src/entities/formattedTariff';
import { getTariffsTable } from '~/src/features/internet/generateTariffSummaryTableFAQ/utils/getTariffsTable';

export interface IProps {
    tariffsForPage: ITariff[],
    companyName: string,
    code?: string,
}

// сводная таблица тарифов SEO в строковом формате для FAQ
export const generateTariffSummaryTable = ({ tariffsForPage, companyName, code }: IProps): string => {
    const tableData = getTariffsTable({
        tariffsForPage,
        code,
    });

    const headerRow = <tr>
        {tableData.head.map(({ th, id }) => <th key={id}><b>{th}</b></th>)}
    </tr>;

    const bodyRows = <>
        {tableData.rows.map((row, index) => <tr key={index}>
            {row.map((value) => <td dangerouslySetInnerHTML={{ __html: value }} key={value}/>)}
        </tr>)}
    </>;

    return renderToString(<table>
        <caption>{tableData.caption} {companyName}</caption>
        <thead>{headerRow}</thead>
        <tbody>{bodyRows}</tbody>
    </table>);
};
